import type { CommissionType, DividendTiming, GroupStatus } from "../services/types";

export const GROUP_STATUSES: { value: GroupStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const GROUP_STATUS_LABEL: Record<GroupStatus, string> = {
  draft: "Draft",
  active: "Active",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const GROUP_STATUS_BADGE: Record<GroupStatus, "pending" | "active" | "completed" | "cancelled"> = {
  draft: "pending",
  active: "active",
  completed: "completed",
  cancelled: "cancelled",
};

export const COMMISSION_TYPES: { value: CommissionType; label: string; helper: string }[] = [
  { value: "none", label: "None", helper: "No separate commission — the reserved full-pool cycle is the earning." },
  { value: "pool_percentage", label: "Percentage of installment", helper: "Applied on the base installment after dividend each cycle." },
  { value: "discount_percentage", label: "Percentage of the discount", helper: "A cut of the winning discount from each auction." },
  { value: "fixed", label: "Fixed amount", helper: "A flat amount charged per cycle." },
];

export const COMMISSION_LABEL: Record<CommissionType, string> = {
  none: "None",
  pool_percentage: "Percentage of installment (after dividend)",
  discount_percentage: "Percentage of the discount",
  fixed: "Fixed amount",
};

export const DIVIDEND_TIMING_OPTIONS: { value: DividendTiming; label: string; helper: string }[] = [
  {
    value: "same_month",
    label: "Same month's installment",
    helper: "The dividend reduces that same month's installment, so collection exactly equals the payout and no float is held.",
  },
  {
    value: "next_month",
    label: "Following month's installment",
    helper: "The dividend is credited against the next month's installment instead.",
  },
];

export const DIVIDEND_TIMING_LABEL: Record<DividendTiming, string> = {
  same_month: "Same month",
  next_month: "Following month",
};

/** The organizer's reserved cycle default — cycle two, no auction, full pool. */
export const DEFAULT_RESERVED_CYCLE = 2;

/** Auction and due days are limited to the first 28 days so every month is identical. */
export const DAY_OPTIONS = Array.from({ length: 28 }, (_, i) => ({
  value: String(i + 1),
  label: `${i + 1}${daySuffix(i + 1)}`,
}));

function daySuffix(n: number): string {
  if (n === 1 || n === 21) return "st";
  if (n === 2 || n === 22) return "nd";
  if (n === 3 || n === 23) return "rd";
  return "th";
}